import React from 'react';
import EmailConfirmationInvalidTokenErrorPage from './EmailConfirmationInvalidTokenErrorPage';
import EmailConfirmationFormPage from './EmailConfirmationFormPage';
import EmailConfirmationFormPageOld from './EmailConfirmationFormPage.old';
import { useAppSelector } from '../stores/redux.store';
import { checkFeatureGate } from '../utilities/feature-flags/feature-gate';
import { AidFrontendFeatureGate } from '../providers/FeatureGates';
import { fetchPageState } from '../utilities/fetch-api';

export async function changeEmailLoader({ request }: { request: Request }) {
  return await fetchPageState('/rest/verify-email/change-email/state', request, {
    capabilities: ['capability-group--manage-profile', 'capability-name--change-email'],
  });
}

export const EmailConfirmationPage = () => {
  const error = useAppSelector(state => state.changeEmail.error);

  const isFeatureGateEnabled = checkFeatureGate(
    AidFrontendFeatureGate.ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL
  );

  if (error === 'invalid_token') {
    return <EmailConfirmationInvalidTokenErrorPage />;
  }

  if (isFeatureGateEnabled) {
    return <EmailConfirmationFormPage />;
  }

  return <EmailConfirmationFormPageOld />;
};

export default EmailConfirmationPage;
